var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIndicacaoP1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 95,
    viewBox: "0 0 94 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 52.0999L74.1 48.0999L45.5 64.0998L56.5 52.0999Z",
    fill: "url(#paint0_linear_20693_16694)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.18 94.9601C78.76 94.9601 78.32 94.9201 77.88 94.8201L77.76 94.7801L52.32 87.4801C49.66 86.8801 47.58 84.6401 47 81.7001L40.26 59.9401L40.24 59.8401C39.48 55.6801 41.92 51.6601 45.68 50.9001L85.74 41.7401H85.76C87.74 41.3401 89.76 41.9201 91.32 43.3201C93.12 44.9601 94.04 47.4601 93.78 50.0201V50.1201L93.76 50.2001L92.4 56.2001C92.24 56.9001 91.38 57.1601 90.86 56.6601L89.6 55.4401C89.3 55.1401 89.16 54.7001 89.24 54.2801L90.2 49.5601C90.32 48.1601 89.84 46.8401 88.9 46.0001C88.5 45.6401 87.64 45.0601 86.5 45.2801L46.44 54.4401H46.42C44.62 54.8001 43.42 56.9201 43.78 59.1001L50.5 80.8401L50.52 80.9401C50.8 82.4801 51.86 83.7001 53.12 83.9601L53.24 84.0001L78.66 91.3001C79.58 91.4801 80.32 91.1201 80.78 90.7801C81.64 90.1401 82.22 89.0801 82.34 87.8801V87.7801L86.2 69.2201C86.24 69.0201 86.32 68.8401 86.46 68.6801L89.54 64.9201C89.94 64.4201 90.74 64.8001 90.6 65.4201L85.94 88.3401C85.7 90.5401 84.6 92.4801 82.94 93.7001C81.8 94.5201 80.5 94.9601 79.18 94.9601Z",
    fill: "#FF8B22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6202 55.36C77.5602 55.36 77.5002 55.38 77.4402 55.38C75.6802 55.42 73.9202 55.48 72.1602 55.5C70.1802 55.52 68.2202 55.7 66.2602 56.04C64.1602 56.4 62.1402 57.04 60.2402 58.06C57.5002 59.56 55.6402 61.78 54.7202 64.74C54.2202 66.36 53.9802 68.02 54.0002 69.7C54.0202 70.6 53.9802 71.52 54.1402 72.4C54.7402 75.82 56.3202 78.84 58.1802 81.74C58.2802 81.9 58.4402 82.06 58.6002 82.18C58.8602 82.4 59.1402 82.3 59.4002 82.14C59.6402 81.98 59.8402 81.78 59.8002 81.44C59.7002 80.44 59.6002 79.42 59.5202 78.4C59.4002 76.52 59.4602 74.66 59.8802 72.8C60.5602 69.68 62.3802 67.6 65.4202 66.56C67.3402 65.9 69.3402 65.56 71.3602 65.5C73.3602 65.44 75.3602 65.46 77.3602 65.44C77.5802 65.44 77.6002 65.54 77.6002 65.72C77.6202 67.36 77.6002 69.02 77.6602 70.66C77.6802 71.68 78.7802 72.42 79.7402 72.08C80.0402 71.98 80.3402 71.74 80.5602 71.52C83.3602 68.74 86.1602 65.96 88.9402 63.18C89.5002 62.62 90.0802 62.06 90.6002 61.46C91.2202 60.76 91.2202 60.14 90.6402 59.4C90.5002 59.22 90.3402 59.04 90.1602 58.86C87.3602 56.06 84.5602 53.24 81.7402 50.46C81.2402 49.96 80.7402 49.48 80.2002 49.02C79.6202 48.54 78.8402 48.56 78.2402 49.02C77.7002 49.42 77.5802 49.96 77.5802 50.58C77.6202 52.18 77.6202 53.74 77.6202 55.36Z",
    fill: "url(#paint1_linear_20693_16694)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6201 55.3601C77.6201 53.7601 77.6201 52.1801 77.6201 50.6201C77.6201 50.0001 77.7601 49.4601 78.2801 49.0601C78.9001 48.6001 79.6601 48.5801 80.2401 49.0601C80.7801 49.5001 81.2801 50.0001 81.7801 50.5001C84.5801 53.3001 87.4001 56.1001 90.2001 58.9001C90.3601 59.0601 90.5401 59.2401 90.6801 59.4401C91.2601 60.1801 91.2601 60.8001 90.6401 61.5001C90.1201 62.1001 89.5401 62.6601 88.9801 63.2201C86.1801 66.0001 83.4001 68.7801 80.6001 71.5601C80.3601 71.8001 80.0801 72.0201 79.7801 72.1201C78.8201 72.4601 77.7201 71.7201 77.7001 70.7001C77.6601 69.0601 77.6601 67.4001 77.6401 65.7601C77.6401 65.5801 77.6201 65.4801 77.4001 65.4801C75.4001 65.5001 73.4001 65.4601 71.4001 65.5401C69.3801 65.6001 67.4001 65.9401 65.4601 66.6001C62.4201 67.6401 60.6201 69.7201 59.9201 72.8401C59.5201 74.7001 59.4401 76.5601 59.5601 78.4401C59.6201 79.4601 59.7401 80.4601 59.8401 81.4801C59.8801 81.8201 59.6801 82.0201 59.4401 82.1801C59.1801 82.3401 58.9201 82.4201 58.6401 82.2201C58.4801 82.1001 58.3201 81.9401 58.2201 81.7801C56.3601 78.9001 54.7801 75.8801 54.1801 72.4401C54.0201 71.5601 54.0601 70.6401 54.0401 69.7401C54.0201 68.0401 54.2401 66.3801 54.7601 64.7801C55.7001 61.8201 57.5401 59.6001 60.2801 58.1001C62.1801 57.0801 64.1801 56.4401 66.3001 56.0801C68.2401 55.7401 70.2201 55.5601 72.2001 55.5401C73.9601 55.5201 75.7201 55.4601 77.4801 55.4201C77.5001 55.3601 77.5401 55.3601 77.6201 55.3601Z",
    fill: "url(#paint2_linear_20693_16694)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2002 29.4799L68.6002 23.2799C68.4802 23.4399 68.3602 23.5999 68.2402 23.7399C65.8802 26.2399 60.8002 25.2799 56.9002 21.5999C52.9802 17.9199 51.7202 12.8999 54.0602 10.3999C54.2002 10.2599 54.3402 10.1199 54.5002 9.99993L48.8402 4.67993L16.2402 39.3599L42.6202 64.1599L75.2002 29.4799Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.88013 49.86L10.4801 56.06C10.6001 55.9 10.7201 55.74 10.8401 55.6C13.2001 53.1 18.2801 54.06 22.1801 57.74C26.1001 61.42 27.3601 66.44 25.0201 68.94C24.8801 69.08 24.7401 69.22 24.5801 69.34L30.2401 74.66L41.3601 62.84L15.0001 38.02L3.88013 49.86Z",
    fill: "#FF5AAD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1847 44.4133L46.8816 45.8545L38.1107 24.7423L41.3936 23.3227L50.1847 44.4133ZM39.2255 41.1743C36.977 43.5662 33.4097 43.9067 30.8022 41.4556C28.4534 39.2476 28.1547 35.679 30.6058 33.0716C32.8746 30.658 36.4203 30.2973 39.0062 32.7282C41.3767 34.9564 41.6968 38.5453 39.2255 41.1743ZM37.0046 39.046C38.058 37.9254 37.8201 36.3217 36.6996 35.2684C35.4712 34.1137 33.8826 34.1629 32.9103 35.1972C31.8772 36.2962 32.0948 37.9215 33.2154 38.9749C34.4221 40.1092 36.0526 40.0588 37.0046 39.046ZM57.4349 35.9664C55.1864 38.3584 51.6191 38.6988 49.0332 36.268C46.6628 34.0397 46.3641 30.4711 48.8152 27.8637C51.0839 25.4502 54.6512 25.1097 57.2372 27.5405C59.6076 29.7688 59.9062 33.3374 57.4349 35.9664ZM55.214 33.8381C56.2674 32.7176 56.0295 31.1139 54.9089 30.0605C53.7022 28.9261 52.1135 28.9753 51.1412 30.0096C50.0879 31.1302 50.3042 32.7136 51.4248 33.767C52.6315 34.9014 54.2417 34.8725 55.214 33.8381Z",
    fill: "#FF5AAD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.2246 -0.676025L57.9674 9.42592L57.3331 11.3083C56.4628 13.8913 57.0999 16.8299 59.2004 18.8053L59.2042 18.8088L59.2079 18.8123C61.2825 20.7763 64.2626 21.2396 66.7969 20.2118L68.6352 19.4663L79.3746 29.5649L31.6774 80.3131L20.8771 70.1784L21.4401 68.3355C22.2058 65.8299 21.5372 62.9804 19.4941 61.0493C17.4644 59.1308 14.5985 58.6363 12.1215 59.56L10.3224 60.2308L-0.476074 50.0978L47.2246 -0.676025ZM47.4957 8.07595L8.2763 49.8221L11.8802 53.204C15.9993 52.3409 20.4558 53.4406 23.7462 56.5507C27.0225 59.6475 28.4035 64.0263 27.7989 68.185L31.4028 71.5668L70.6257 29.835L67.1574 26.5736C62.9588 27.5612 58.3423 26.5144 54.956 23.3111C51.5604 20.1154 50.2295 15.5843 50.9608 11.3343L47.4957 8.07595Z",
    fill: "url(#paint3_linear_20693_16694)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8254 54.8169C34.0752 53.4833 36.1695 53.4154 37.5032 54.6652L37.7419 54.889C37.8225 54.9645 37.8984 55.043 37.9697 55.1244C38.0555 55.1903 38.1388 55.2609 38.2194 55.3365L38.6969 55.784C38.7775 55.8595 38.8534 55.938 38.9247 56.0194C39.0105 56.0853 39.0938 56.1559 39.1744 56.2315L39.6519 56.679C39.7325 56.7545 39.8084 56.833 39.8797 56.9144C39.9655 56.9803 40.0488 57.0509 40.1294 57.1265L40.6069 57.574C40.6875 57.6495 40.7634 57.728 40.8347 57.8094C40.9205 57.8753 41.0038 57.9459 41.0844 58.0215L41.3232 58.2452C42.6568 59.495 42.7247 61.5894 41.4749 62.923C40.225 64.2566 38.1307 64.3246 36.7971 63.0747L36.5583 62.851C36.4778 62.7755 36.4018 62.6969 36.3305 62.6156C36.2447 62.5497 36.1614 62.479 36.0808 62.4035L35.6033 61.956C35.5228 61.8805 35.4468 61.8019 35.3755 61.7206C35.2897 61.6547 35.2064 61.584 35.1258 61.5085L34.6483 61.061C34.5678 60.9855 34.4918 60.9069 34.4205 60.8256C34.3347 60.7597 34.2514 60.689 34.1708 60.6135L33.6933 60.166C33.6128 60.0905 33.5368 60.0119 33.4655 59.9306C33.3797 59.8647 33.2964 59.794 33.2158 59.7185L32.9771 59.4947C31.6434 58.2449 31.5755 56.1505 32.8254 54.8169Z",
    fill: "url(#paint4_linear_20693_16694)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7913 47.2505C26.0446 45.9202 28.1391 45.8577 29.4694 47.1111L29.7069 47.3348C29.7871 47.4103 29.8626 47.4889 29.9335 47.5701C30.0189 47.6361 30.1018 47.7068 30.1819 47.7823L30.6569 48.2298C30.7371 48.3053 30.8126 48.3839 30.8835 48.4651C30.9689 48.5311 31.0518 48.6018 31.1319 48.6773L31.6069 49.1248C31.6871 49.2003 31.7626 49.2789 31.8335 49.3601C31.9189 49.4261 32.0018 49.4968 32.0819 49.5723L32.5569 50.0198C32.6371 50.0953 32.7126 50.1739 32.7835 50.2551C32.8689 50.3211 32.9518 50.3918 33.0319 50.4673L33.2694 50.6911C34.5998 51.9444 34.6622 54.0389 33.4089 55.3693C32.1556 56.6996 30.0611 56.762 28.7307 55.5087L28.4932 55.285C28.4131 55.2095 28.3375 55.1309 28.2666 55.0497C28.1813 54.9837 28.0984 54.913 28.0182 54.8375L27.5432 54.39C27.4631 54.3145 27.3875 54.2359 27.3166 54.1547C27.2313 54.0887 27.1484 54.018 27.0682 53.9425L26.5932 53.495C26.5131 53.4195 26.4375 53.3409 26.3666 53.2597C26.2813 53.1937 26.1984 53.123 26.1182 53.0475L25.6432 52.6C25.5631 52.5245 25.4875 52.4459 25.4166 52.3647C25.3313 52.2987 25.2484 52.228 25.1682 52.1525L24.9307 51.9287C23.6004 50.6754 23.5379 48.5809 24.7913 47.2505Z",
    fill: "url(#paint5_linear_20693_16694)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7316 39.6703C17.9851 38.3402 20.0796 38.2781 21.4098 39.5316L21.6485 39.7566C21.7291 39.8325 21.805 39.9116 21.8762 39.9933C21.9621 40.0596 22.0454 40.1307 22.126 40.2066L22.6035 40.6566C22.6841 40.7325 22.76 40.8116 22.8312 40.8933C22.9171 40.9596 23.0004 41.0307 23.081 41.1066L23.5585 41.5566C23.6391 41.6325 23.715 41.7116 23.7862 41.7933C23.8721 41.8596 23.9554 41.9307 24.036 42.0066L24.5135 42.4566C24.5941 42.5325 24.67 42.6116 24.7412 42.6933C24.8271 42.7596 24.9104 42.8307 24.991 42.9066L25.2298 43.1316C26.5599 44.3852 26.622 46.4797 25.3685 47.8098C24.1149 49.14 22.0204 49.2021 20.6903 47.9485L20.4515 47.7235C20.371 47.6476 20.295 47.5686 20.2238 47.4868C20.138 47.4205 20.0546 47.3494 19.974 47.2735L19.4965 46.8235C19.416 46.7476 19.34 46.6686 19.2688 46.5868C19.183 46.5205 19.0996 46.4494 19.019 46.3735L18.5415 45.9235C18.461 45.8476 18.385 45.7686 18.3138 45.6868C18.228 45.6205 18.1446 45.5494 18.064 45.4735L17.5865 45.0235C17.506 44.9476 17.43 44.8686 17.3588 44.7868C17.273 44.7205 17.1896 44.6494 17.109 44.5735L16.8703 44.3485C15.5401 43.095 15.478 41.0005 16.7316 39.6703Z",
    fill: "url(#paint6_linear_20693_16694)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20693_16694",
    x1: 45.5,
    y1: 56.0999,
    x2: 74.1,
    y2: 56.0999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3774,
    stopColor: "#B5B5B5",
    stopOpacity: 0.6226
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7958,
    stopColor: "#EAEAEA",
    stopOpacity: 0.2042
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20693_16694",
    x1: 54.0202,
    y1: 65.5055,
    x2: 91.0917,
    y2: 65.5055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC41D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0770749,
    stopColor: "#A641D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4555,
    stopColor: "#8E40B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7765,
    stopColor: "#7E3F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#793F98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20693_16694",
    x1: 54.0201,
    y1: 65.5055,
    x2: 91.0916,
    y2: 65.5055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC41D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0770749,
    stopColor: "#A641D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4555,
    stopColor: "#8E40B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7765,
    stopColor: "#7E3F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#793F98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_20693_16694",
    x1: 16.2656,
    y1: 64.4832,
    x2: 62.6304,
    y2: 15.1601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC41D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0770749,
    stopColor: "#A641D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4555,
    stopColor: "#8E40B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7765,
    stopColor: "#7E3F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#793F98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_20693_16694",
    x1: 35.6025,
    y1: 60.5181,
    x2: 38.7002,
    y2: 57.2227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC41D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0770749,
    stopColor: "#A641D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4555,
    stopColor: "#8E40B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7765,
    stopColor: "#7E3F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#793F98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_20693_16694",
    x1: 27.552,
    y1: 52.9504,
    x2: 30.6497,
    y2: 49.6551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC41D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0770749,
    stopColor: "#A641D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4555,
    stopColor: "#8E40B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7765,
    stopColor: "#7E3F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#793F98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_20693_16694",
    x1: 19.5015,
    y1: 45.383,
    x2: 22.5992,
    y2: 42.0876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC41D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0770749,
    stopColor: "#A641D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4555,
    stopColor: "#8E40B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7765,
    stopColor: "#7E3F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#793F98"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIndicacaoP1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/indicacao_p1.840bd7b9e5792e858013a99272e20b27.svg";